






























import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import * as def from "@/definitions";

import { UserAgentHelper } from "@/helper/userAgentHelper"
import Spinner from "vue-spinkit";

import { CookieHelper } from "@/helper/cookieHelper"
import { RequestHelper } from "@/helper/requestHelper"
import { DebugHelper } from "@/helper/debugHelper";
import platform from '@/helper/platform';

@Component({
  components: {
      Spinner
  }
})

export default class PrintLoading extends Vue
{
    // 待ち人数
    @Prop() waitNumber! : number;

    @Prop() isVisible! : boolean;
    @Watch("isVisible")
    onIsVisibleChanged(val: boolean, oldVal: boolean)
    {
        // モーダル表示モード
        this.$store.getters.applicationState.modalMode = val ? 1 : 0;
    }

    productUrl = "";
    imagePath = "";
    recommendId = "";
    private get message()
    {
        return this.waitNumber < 0 || this.waitNumber == 0 ? "" : "印刷処理は現在" + this.waitNumber + "人待ちです。しばらくお待ちください。";
    }

    close()
    {
        // キャンセルを発行する
        this.$emit("cancel");
    }

    get browser(){
        return UserAgentHelper.getBrowser()
    }

    get userConfigColor(){
        return this.$store.getters.userConfigColors.buttonColorCode;
    }

    private get buttonColorStyle(){
        return {
            "background" : this.userConfigColor
        }
    }

    private get isElectron(): boolean {
        return UserAgentHelper.isElectron();
    }
}
